(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-swf-community]').forEach(section => {
      if (section.dataset.swfInitialized) return;
      section.dataset.swfInitialized = 'true';
      const track = section.querySelector('.swf-home-community__track');
      const previous = section.querySelector('[data-swf-previous]');
      const next = section.querySelector('[data-swf-next]');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();move(event.key === 'ArrowLeft' ? -1 : 1);}
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
